<template>
  <div class="nav-container">
    <div class="nav-body">
      <!-- 侧边导航 -->
      <div class="nav-side" ref="navSide">
        <ul>
          <li :class="{'active': panelActiveIndex == (index+1)}" 
            @mouseenter="showDetail(index+1)" 
            @mouseleave="hideDetail()"
            v-for="(item, index) in  classifyList" :key="'navSide_'+item.id">
            <div class="nav-side-main">
              <router-link :to="'/list/'+item.id">
                {{item.name}}
              </router-link>
            </div>
            <div class="nav-side-item">
              <template v-for="(value, n) in item.children">
                <span :key="'navSideItem_'+value.id" v-if="n < 3">
                  <router-link :to="'/list/'+value.id">
                    {{value.name}}
                  </router-link>
                </span>
              </template>
            </div>
          </li>
        </ul>
      </div>
      <div class="nav-content">
        <!-- 幻灯片 -->
        <a @click="goto(bannerList[0])" v-if="bannerList && bannerList.length == 1">
          <img class="carouse-image" :src="bannerList[0].imgUrl" alt="">
          <!-- <div class="carouse-image-bg" :style="{'background-image': 'url(' + bannerList[0].imgUrl + ')'}"></div> -->
        </a>
        <Carousel class="home-carousel" autoplay loop arrow="always" :autoplay-speed="3000">
            <CarouselItem  v-for="(item, index) in bannerList" :key="index">
              <a @click="goto(item)">
                <img class="carouse-image" :src="item.imgUrl" alt="">
                <!-- <div class="carouse-image-bg" :style="{'background-image': 'url(' + item.imgUrl + ')'}"></div> -->
              </a>
            </CarouselItem>
        </Carousel>
      </div>
    </div>
    <div class="detail-item-panel-box"  ref="itemPanel">
      <template v-for="(classify, n) in  classifyList">
        <div class="detail-item-panel"
          :key="'itemPanel_'+n"
          v-show="panelActiveIndex == (n+1)" 
          @mouseenter="showDetail(n+1)"  
          @mouseleave="hideDetail()"
          v-if="classify.children">
          <ul>
            <li v-for="(items, index) in classify.children" :key="index" class="detail-item-row">
              <div class="detail-item-title">
                <router-link :to="'/list/'+items.id">
                  {{items.name}}
                </router-link>
              </div>
              <template v-for="(item, subIndex) in items.children">
                <router-link :to="'/list/'+item.id" :key="subIndex" v-if="subIndex < 3">
                  <span class="detail-item">{{item.name}}</span>
                </router-link>
              </template>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'HomeNav',
  data () {
    return {
      panelActiveIndex: 0,
    };
  },
  computed: {
    ...mapState(['bannerList', 'classifyList'])
  },
  watch: {
    "$route"() {
      this.panelActiveIndex = 0
    },
  },
  mounted () {
    this.$refs.itemPanel.style.left = this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
    this.$refs.itemPanel.style.top = this.$refs.navSide.offsetTop + 'px';
  },
  updated () {
    this.$refs.itemPanel.style.left = this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
    this.$refs.itemPanel.style.top = this.$refs.navSide.offsetTop + 'px';
  },
  methods: {
    showDetail (index) {
      this.panelActiveIndex = index
    },
    hideDetail () {
      this.panelActiveIndex = 0
    },
    goto(item) {
      item.linkParam && window.open(item.linkParam)
    }
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/nav-side";

.nav-container {
  width: 100%;
  min-height: 640px; 
}
/*大的导航信息，包含导航，幻灯片等*/
.nav-body {
  width: @page-main-width;
  min-height: 580px;
  margin: 0px auto;
  display: flex;
}

.detail-item-panel-box {
  position: absolute;
  top: 230px;
  left: 348px;
}

/*导航内容*/
.nav-content {
  width: 972px;
  // height: 560px;
  height: 627px;
  // margin-left: 15px;
  overflow: hidden;
  float: left;

  /deep/.ivu-carousel-dots li > button {
    height: 4px;
  }

  /deep/.ivu-carousel-dots li.ivu-carousel-active > button {
    background-color: @theme-code;
    opacity: 1;
  }
}
/deep/.home-carousel{
  font-size: 0 !important;
  height: 627px;
  a {
    font-size: 0;
  }
}
/deep/.ivu-carousel-dots{
  bottom: 15px;
}
.carouse-image {
  width: 100%; 
  height: 627px;
  display: block;
  // border-left: 1px solid transparent;
  // border-right: 1px solid transparent;
  // border-top: none;
  // border-bottom: none;
  // box-sizing: border-box;
}
.carouse-image-bg {
  width: 100%; 
  // height: 560px;
  height: 627px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>

<style>
  .ivu-carousel-arrow{
    background-color: rgb(31 45 61 / 47%);
  }
</style>



// WEBPACK FOOTER //
// src/components/nav/HomeNav.vue